import Entrypoint from './Entrypoint';

export default Entrypoint;
